import {
  GET_CAMPAIGNDETAIL,
  GET_CAMPAIGNDETAIL_SUCCESS,
  GET_CAMPAIGNDETAIL_FAIL,
  DELETE_CAMPAIGNDETAIL,
  DELETE_CAMPAIGNDETAIL_SUCCESS,
  DELETE_CAMPAIGNDETAIL_FAIL,
  UPDATE_CAMPAIGNDETAIL,
  UPDATE_CAMPAIGNDETAIL_SUCCESS,
  UPDATE_CAMPAIGNDETAIL_FAIL,
  ADD_NEW_CAMPAIGNDETAIL,
  ADD_CAMPAIGNDETAIL_SUCCESS,
  ADD_CAMPAIGNDETAIL_FAIL,
  CAMPAIGNDETAIL_LOADING,
  CAMPAIGNDETAIL_RESET,
} from "./actionType";

export const resetCampaignDetailState = (actionType) => ({
  type: CAMPAIGNDETAIL_RESET,
  payload: { actionType },
});

export const getCampaignDetailSuccess = (actionType, data) => ({
  type: GET_CAMPAIGNDETAIL_SUCCESS,
  payload: { actionType, data },
});

export const getCampaignDetailFail = (actionType, error) => ({
  type: GET_CAMPAIGNDETAIL_FAIL,
  payload: { actionType, error },
});

export const getCampaignDetail = data => ({
  type: GET_CAMPAIGNDETAIL,
  payload: data,
});

export const getCampaignDetailLoading = () => ({
  type: CAMPAIGNDETAIL_LOADING
});

export const deleteCampaignDetail = data => ({
  type: DELETE_CAMPAIGNDETAIL,
  payload: data,
});

export const deleteCampaignDetailSuccess = data => ({
  type: DELETE_CAMPAIGNDETAIL_SUCCESS,
  payload: data,
});

export const deleteCampaignDetailFail = error => ({
  type: DELETE_CAMPAIGNDETAIL_FAIL,
  payload: error,
});

export const updateCampaignDetail = data => ({
  type: UPDATE_CAMPAIGNDETAIL,
  payload: data,
});

export const updateCampaignDetailFail = error => ({
  type: UPDATE_CAMPAIGNDETAIL_FAIL,
  payload: error,
});

export const updateCampaignDetailSuccess = data => ({
  type: UPDATE_CAMPAIGNDETAIL_SUCCESS,
  payload: data,
});

export const addNewCampaignDetail = data => ({
  type: ADD_NEW_CAMPAIGNDETAIL,
  payload: data,
});

export const addCampaignDetailSuccess = data => ({
  type: ADD_CAMPAIGNDETAIL_SUCCESS,
  payload: data,
});

export const addCampaignDetailFail = error => ({
  type: ADD_CAMPAIGNDETAIL_FAIL,
  payload: error,
});